module.exports = "<footer> <div class=\"footer-copyright\"> <span class=\"footer-text-copyright\">&copy; Gestão de Frotas</span> </div> <div class=\"footer-middle\"> <i *ngIf=\"isLoading\"><span class=\"footer-welcome\">Carregando dados...</span></i> </div> <div class=\"footer-legenda\"> </div> </footer>";


//////////////////
// WEBPACK FOOTER
// ./app/core/components/custom-footer/custom-footer.component.html
// module id = 1130
// module chunks = 7